import { ArticleResolution } from '@wix/answers-api';
import {
  Box,
  CustomModalLayout,
  Loader,
  Text,
  Button,
} from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent } from 'react';
import { DATA_HOOKS } from '../../../dataHooks';
import { COLORS } from '../../../utils/theme';
import css from './index.module.scss';

export type RoadmapFeatureRequestSuccessModalProps = {
  onClose: () => void;
  isLoading: boolean;
  resolution?: ArticleResolution;
};
export const RoadmapFeatureRequestSuccessModal: FunctionComponent<
  RoadmapFeatureRequestSuccessModalProps
> = ({ onClose, isLoading, resolution }) => {
  const { t } = useTranslation();

  const successModal = (
    <Box
      padding={'100px 0'}
      direction="vertical"
      align="center"
      verticalAlign="middle"
    >
      <Box
        direction="vertical"
        align="center"
        verticalAlign="middle"
        padding="SP4"
      >
        <Text
          className={css.successModalTitle}
          dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_TITLE}
          textAlign="center"
          size="medium"
          weight="bold"
        >
          {resolution
            ? resolution === ArticleResolution.COLLECTING_VOTES
              ? t('feature-request.modal.success.title.vote')
              : t('feature-request.modal.success.title.follow')
            : t('feature-request.modal.success.title')}
        </Text>
        <Text
          className={css.successModalSubtitle}
          dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_SUBTITLE}
          textAlign="center"
          size="medium"
        >
          {resolution
            ? t('feature-request.modal.success.sub-title.vote')
            : t('feature-request.modal.success.sub-title')}
        </Text>
      </Box>
      {!resolution && (
        <Text
          textAlign="center"
          dataHook={
            DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_DESCRIPTION
          }
          className={css.successModalDescription}
          size="medium"
        >
          {t('feature-request.modal.success.description')}
        </Text>
      )}
      <Button
        dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_SUCCESS_MODAL_CLOSE_BUTTON}
        onClick={onClose}
        size="small"
      >
        {t('feature-request.modal.success.close-button')}
      </Button>
    </Box>
  );

  return (
    <CustomModalLayout
      className={css.featureRequestSuccessModal}
      onCloseButtonClick={onClose}
      content={
        isLoading ? (
          <Box
            align="center"
            verticalAlign="middle"
            width={'100%'}
            height={'500px'}
          >
            <Loader size="large" />
          </Box>
        ) : (
          successModal
        )
      }
      width={'600px'}
    />
  );
};
